let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a8qvQ")).then(() => parcelRequire('9uLfO'));